import React, { useEffect, useState } from 'react'
import axios from 'axios'
import {
  Table,
  Input,
  Modal,
  Row,
  Col,
  DatePicker,
  Select,
  Button,
  Space,
} from 'antd'
import AdminHeader from '../CommonComponent/AdminHeader'
import Footer from '../CommonComponent/Footer'
import { EyeOutlined, EditOutlined } from '@ant-design/icons'
import {
  ApprovedRegStudentList,
  IMG_BASE_URL,
  UpdateApprovedRegStudentData,
} from '../../AllAPI/AdminAPI'
import dayjs from 'dayjs'
import { toast } from 'react-toastify'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
const { Option } = Select


const RegApprovedList = () => {
  const [fileKey, setFileKey] = useState(Date.now())

  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(false)
  const [imagePreview, setImagePreview] = useState(null)
  const [viewModal, setViewModal] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  const [editModal, setEditModal] = useState(false)
  const [selectedId, setSelectedId] = useState(null)

  // form states

  const [FName, setFName] = useState('')
  const [MName, setMName] = useState('')
  const [LName, setLName] = useState('')
  const [studentName, setStudentName] = useState('')
  const [email, setEmail] = useState('')
  const [gender, setGender] = useState('')
  const [mobile, setMobile] = useState('')
  const [changedName, setChangedName] = useState('')
  const [dob, setDob] = useState(null)
  const [bloodGroup, setBloodGroup] = useState('')
  const [dropoutClass, setDropoutClass] = useState('')
  const [education, setEducation] = useState('')
  const [occupation, setOccupation] = useState('')
  const [entryType, setEntryType] = useState('')
  const [houseNo, setHouseNo] = useState('')
  const [confirmationForJoining, setConfirmationForJoining] = useState('')
  const [sendingArticlePoems, setSendingArticlePoems] = useState('')
  const [wayOfAttending, setWayOfAttending] = useState('')
  const [studentNewImage, setStudentNewImage] = useState(null)
  const [studentOldImage, setStudentOldImage] = useState(null)
  const [paymentScreenshot, setPaymentScreenshot] = useState(null)
  const [studentNewImageUrl, setStudentNewImageUrl] = useState('')
  const [studentOldImageUrl, setStudentOldImageUrl] = useState('')
  const [paymentScreenshotUrl, setPaymentScreenshotUrl] = useState('')

  // REQUIRED FIELDS LIST
  const requiredFields = [
    { value: dob, label: 'Date of Birth' },
    { value: gender, label: 'Gender' },
    { value: bloodGroup, label: 'Blood Group' },
    { value: dropoutClass, label: 'Passout Class' },
    { value: education, label: 'Education' },
    { value: occupation, label: 'Occupation' },
    { value: entryType, label: 'Type of Entry' },
    { value: houseNo, label: 'House No.' },
    { value: confirmationForJoining, label: 'Joining Confirmation' },
    { value: sendingArticlePoems, label: 'Article/Poem Confirmation' },
    { value: wayOfAttending, label: 'Way of Attending' },
  ]

  // =========Image CLick For Showing Big Size=================
  const handleImageClick = (img) => {
    setImagePreview(img)
  }

  const closePreview = () => {
    setImagePreview(null)
  }
  // ========================================

  useEffect(() => {
    fetchApprovedList()
  }, [])

  const fetchApprovedList = async () => {
    setLoading(true)
    try {
      const res = await axios.get(ApprovedRegStudentList)
      setData(res.data)
    } catch (err) {
      console.log(err)
    }
    setLoading(false)
  }

  // ===== Search Filter =====
  const filteredData = data.filter((item) =>
    Object.values(item).join(' ').toLowerCase().includes(search.toLowerCase()),
  )

  // ACTION: OPEN MODAL
  const handleView = (record) => {
    setSelectedRecord(record)
    setViewModal(true)
  }

  // ===== Table Columns =====
  // TABLE COLUMNS
  const columns = [
    {
      title: 'Sr No.',
      dataIndex: 'sr',
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
      width: 80,
    },
    {
      title: 'Student Name',
      render: (_, record) =>
        `${record.fname || ''} ${record.mname || ''} ${
          record.lname || ''
        }`.trim(),
    },
    {
      title: 'Mobile',
      dataIndex: 'mobile',
      width: 130,
    },
    {
      title: 'Email',
      dataIndex: 'email',
    },
    {
      title: 'Amount',
      dataIndex: 'payment_amount',
    },

    // ACTION COLUMN
    {
      title: 'Action',
      key: 'action',
      width: 90,
      render: (_, record) => (
        <Space>
          <EyeOutlined
            onClick={() => handleView(record)}
            style={{ fontSize: 20, color: '#1677ff', cursor: 'pointer' }}
          />
          <EditOutlined
            onClick={() => handleEdit(record)}
            style={{ fontSize: 20, color: '#fa8c16', cursor: 'pointer' }}
          />
        </Space>
      ),
    },
  ]

  const handleEdit = (record) => {
    setSelectedId(record.reg_id)

    setStudentName(`${record.fname} ${record.mname} ${record.lname}` || '')
    setFName(record.fname || '')
    setMName(record.mname || '')
    setLName(record.lname || '')
    setChangedName(record.changed_name || '')
    setMobile(record.mobile || '')
    setEmail(record.email || '')
    setDob(record.date_of_birth ? dayjs(record.date_of_birth) : null)
    setBloodGroup(record.blood_group || '')
    setGender(record.gender?.toString())
    setDropoutClass(record.school_dropout_year || '')
    setEducation(record.education || '')
    setOccupation(record.occupation || '')
    setWayOfAttending(record.way_of_attending?.toString())
    setEntryType(record.entry_type?.toString())
    setConfirmationForJoining(record.confirmation_for_joining?.toString())
    setSendingArticlePoems(record.sending_articles?.toString())
    setHouseNo(record.house_number?.toString())

    setStudentNewImageUrl(record.s_pic || '')
    setStudentOldImageUrl(record.old_pic || '')
    setPaymentScreenshotUrl(record.payment_screenshot || '')

    setStudentNewImage(null)
    setStudentOldImage(null)
    setPaymentScreenshot(null)

    setEditModal(true)
  }

  const handleUpdate = async () => {
    for (let field of requiredFields) {
      if (!field.value || field.value === '') {
        toast.error(`${field.label} is required`)
        return
      }
    }

    const formData = new FormData()

    formData.append('fname', FName)
    formData.append('mname', MName)
    formData.append('lname', LName)
    formData.append('gender', gender)
    formData.append('mobile', mobile)
    formData.append('email', email)
    formData.append('changed_name', changedName)
    formData.append('date_of_birth', dob ? dayjs(dob).format('YYYY-MM-DD') : '')
    formData.append('blood_group', bloodGroup)
    formData.append('school_dropout_year', dropoutClass)
    formData.append('education', education)
    formData.append('occupation', occupation)
    formData.append('entry_type', entryType)
    formData.append('house_number', houseNo)
    formData.append('confirmation_for_joining', confirmationForJoining)
    formData.append('sending_articles', sendingArticlePoems)
    formData.append('way_of_attending', wayOfAttending)
    // formData.append('s_pic', studentNewImage || '')
    // formData.append('old_pic', studentOldImage || '')
    // formData.append('payment_screenshot', paymentScreenshot || '')
    if (studentNewImage) {
      formData.append('s_pic', studentNewImage)
    }

    if (studentOldImage) {
      formData.append('old_pic', studentOldImage)
    }

    if (paymentScreenshot) {
      formData.append('payment_screenshot', paymentScreenshot)
    }

    try {
      setLoading(true)
      await axios.put(
        `${UpdateApprovedRegStudentData}/${selectedId}`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      )

      toast.success('Student Updated Successfully')
      setEditModal(false)
      fetchApprovedList()
    } catch (err) {
      toast.error('Update failed')
    } finally {
      setLoading(false)
    }
  }

  const handleDownloadExcel = () => {
  if (!filteredData || filteredData.length === 0) {
    toast.error('No data available to download')
    return
  }

  // Prepare data for Excel
  const excelData = filteredData.map((item, index) => ({
    'Sr No': index + 1,
    'First Name': item.fname || '',
    'Middle Name': item.mname || '',
    'Last Name': item.lname || '',
    'Changed Name': item.changed_name || '-',
    'Mobile': item.mobile || '',
    'Email': item.email || '',
    'Gender': item.gender === 1 ? 'Male' : 'Female',
    'Date of Birth': item.date_of_birth || '',
    'Blood Group': item.blood_group || '',
    'Education': item.education || '',
    'School Dropout Class/Year': item.school_dropout_year || '',
    'Occupation': item.occupation || '',
    'Payment Amount': item.payment_amount || '',
    'Payment Status': item.payment_status ? 'Paid' : 'Pending',
    'Way Of attending': item.way_of_attending === 1 ? 'Residential' : 'Non Residential',
    'House No': item.house_number || '',
  }))

  // Create worksheet & workbook
  const worksheet = XLSX.utils.json_to_sheet(excelData)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Approved Students')

  // Generate Excel file
  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  })

  const file = new Blob([excelBuffer], {
    type:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  saveAs(file, 'Approved_Student_List.xlsx')
}


  return (
    <div className="bg-gray-100 min-h-screen">
      <AdminHeader />

      <div className="row m-0 p-md-5 pt-0">
        <div className="col-12 col-md-2"></div>

        <div className="col-12 col-md-8 pb-5">
          {/* Header */}
          <header className="reg-header pt-3">
            <h3 className="reg-title pt-1 pt-md-0"> Reg. Approved List </h3>
          </header>

          {/* Search Bar */}
          <div className="row m-0 p-0" style={{ marginTop: '10px' }}>
            <div className="col-12 col-md-8 text-end mb-2 mt-md-1 p-md-0">
                {filteredData.length > 0 && (
                  <Button
                    type="primary"
                    onClick={handleDownloadExcel}
                    style={{ borderRadius: '6px' }} 
                  >
                    Download Excel
                  </Button>
                )}
            </div>
            <div className="col-12 col-md-4">
              <Input
                placeholder="Search here..."
                size="large"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  borderRadius: '8px',
                  border: '1px solid #ccc',
                }}
              />
            </div>
          </div>

          {/* Table */}
          <div style={{ marginTop: '10px' }}>
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredData}
              rowKey="id"
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100'],
                onChange: (page) => {
                  setCurrentPage(page)
                },
                onShowSizeChange: (current, size) => {
                  setPageSize(size)
                  setCurrentPage(1) // reset page
                },
              }}
              bordered={true}
              className="custom-ant-table shadow border"
              style={{ background: 'white', borderRadius: '10px' }}
              scroll={{ x: 'max-content' }}
            />
          </div>

          {/* VIEW MODAL */}
          <Modal
            open={viewModal}
            onCancel={() => setViewModal(false)}
            title="Student Details"
            footer={null}
            width="110vw" // 👈 responsive wide
            style={{ top: 20 }}
            bodyStyle={{
              maxHeight: '80vh',
              overflowY: 'auto',
            }}
            className="custom-modal"
          >
            {selectedRecord && (
              <div className="row p-2 mb-5">
                {/* --- FORM GRID --- */}
                <div className="row">
                  <div className="col-12 mt-2">
                    <label className="font-semibold">Full Name</label>
                    <Input
                      value={`${selectedRecord.fname} ${selectedRecord.mname} ${selectedRecord.lname}`}
                      readOnly
                    />
                  </div>
                  {selectedRecord.changed_name && (
                    <div className="col-12 mt-2">
                      <label className="font-semibold">Changed Name</label>{' '}
                      <br />
                      <Input
                        value={`${selectedRecord.changed_name}`}
                        readOnly
                      />
                    </div>
                  )}

                  <div className="col-12 col-md-6 mt-2">
                    <label className="font-semibold">Email</label>
                    <Input value={selectedRecord.email} readOnly />
                  </div>

                  <div className="col-12 col-md-6 mt-2">
                    <label className="font-semibold">Mobile</label>
                    <Input value={selectedRecord.mobile} readOnly />
                  </div>

                  <div className="col-12 col-md-6 mt-2">
                    <label className="font-semibold">Gender</label>
                    <Input
                      value={selectedRecord.gender === 1 ? 'Male' : 'Female'}
                      readOnly
                    />
                  </div>

                  <div className="col-12 col-md-6 mt-2">
                    <label className="font-semibold">Date of Birth</label>
                    <Input value={selectedRecord.date_of_birth} readOnly />
                  </div>

                  <div className="col-12 col-md-6 mt-2">
                    <label className="font-semibold">Blood Group</label>
                    <Input value={selectedRecord.blood_group} readOnly />
                  </div>

                  <div className="col-12 col-md-6 mt-2">
                    <label className="font-semibold">Education</label>
                    <Input value={selectedRecord.education} readOnly />
                  </div>

                  <div className="col-12 col-md-6 mt-2">
                    <label className="font-semibold">Occupation</label>
                    <Input value={selectedRecord.occupation} readOnly />
                  </div>

                  <div className="col-12 col-md-6 mt-2">
                    <label className="font-semibold">Payment Amount</label>
                    <Input value={selectedRecord.payment_amount} readOnly />
                  </div>

                  <div className="col-12 col-md-6 mt-2">
                    <label className="font-semibold">Payment Status</label>
                    <Input
                      value={selectedRecord.payment_status ? 'Paid' : 'Pending'}
                      readOnly
                    />
                  </div>
                  <div className="col-12 col-md-6 mt-2">
                    <label className="font-semibold">House No</label>
                    <Input
                      value={selectedRecord.house_number}
                      readOnly
                    />
                  </div>


                  {/* --- PROFILE PHOTO --- */}
                  <div
                    className="col-12 col-md-6 mt-2"
                    style={{ marginTop: '20px' }}
                  >
                    <label className="font-semibold">Profile Photo</label>
                    <div
                      style={{
                        border: '2px solid #a3a3a3ff',
                        width: '240px',
                        borderRadius: '8px',
                      }}
                    >
                      <img
                        src={`${IMG_BASE_URL}${selectedRecord.s_pic}`}
                        alt="Profile"
                        onClick={() =>
                          handleImageClick(
                            `${IMG_BASE_URL}${selectedRecord.s_pic}`,
                          )
                        }
                        style={{
                          width: '238px',
                          borderRadius: '8px',
                          objectFit: 'fill',
                          cursor: 'pointer',
                        }}
                      />
                    </div>
                  </div>

                  <div
                    className="col-12 col-md-6 mt-2"
                    style={{ marginTop: '20px' }}
                  >
                    <label className="font-semibold">Old Photo</label>
                    <div
                      style={{
                        border: '2px solid #a3a3a3ff',
                        width: '240px',
                        borderRadius: '8px',
                      }}
                    >
                      <img
                        src={`${IMG_BASE_URL}${selectedRecord.old_pic}`}
                        alt="Profile"
                        onClick={() =>
                          handleImageClick(
                            `${IMG_BASE_URL}${selectedRecord.old_pic}`,
                          )
                        }
                        style={{
                          width: '238px',
                          borderRadius: '8px',
                          objectFit: 'fill',
                          cursor: 'pointer',
                        }}
                      />
                    </div>
                  </div>

                  {/* --- PAYMENT SCREENSHOT --- */}
                  <div
                    className="col-12 col-md-6 mt-2"
                    style={{ marginTop: '20px', marginBottom: '20px' }}
                  >
                    <label className="font-semibold">Payment Screenshot</label>
                    <div
                      style={{
                        border: '2px solid #a3a3a3ff',
                        width: '260px',
                        borderRadius: '8px',
                      }}
                    >
                      <img
                        src={`${IMG_BASE_URL}${selectedRecord.payment_screenshot}`}
                        alt="Payment Screenshot"
                        onClick={() =>
                          handleImageClick(
                            `${IMG_BASE_URL}${selectedRecord.payment_screenshot}`,
                          )
                        }
                        style={{
                          width: '257px',
                          borderRadius: '8px',
                          cursor: 'pointer',
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Modal>

          {imagePreview && (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                background: 'rgba(0,0,0,0.7)',
                backdropFilter: 'blur(5px)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
              }}
              onClick={closePreview}
            >
              {/* CLOSE BUTTON */}
              <button
                onClick={closePreview}
                style={{
                  position: 'absolute',
                  top: '20px',
                  right: '30px',
                  fontSize: '30px',
                  background: 'transparent',
                  color: 'white',
                  border: 'none',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                }}
              >
                ✖
              </button>

              {/* IMAGE */}
              <img
                src={imagePreview}
                alt="Preview"
                style={{
                  maxWidth: '90%',
                  maxHeight: '90%',
                  borderRadius: '10px',
                  boxShadow: '0 0 20px rgba(255,255,255,0.5)',
                }}
                onClick={(e) => e.stopPropagation()} // stop closing when clicking image
              />
            </div>
          )}

          {/* UPDATE MODAL */}
          <Modal
            open={editModal}
            onCancel={() => setEditModal(false)}
            title="Edit Student Details"
            wrapClassName="custom-wide-modal"
            style={{ top: 20, bottom: 20 }}
            bodyStyle={{
              maxHeight: '80vh',
              overflowY: 'auto',
            }}
            footer={null}
          >
            <>
              <Row gutter={[16, 16]}>
                <Col sm={24} md={12} className="mt-3">
                  <label className="font-semibold">Student Name</label>
                  <Input
                    value={studentName}
                    // onChange={(e) => setStudentName(e.target.value)}
                    placeholder="Enter student name"
                    className="mt-1"
                    required
                    disabled
                  />
                </Col>
                {/* Changed Name */}
                <Col sm={24} md={12} className="mt-3">
                  <label className="font-semibold">
                    Changed Name (Only For Girls)
                  </label>
                  <Input
                    required
                    value={changedName}
                    onChange={(e) => setChangedName(e.target.value)}
                    placeholder="Enter changed name"
                    className="mt-1"
                  />
                </Col>
                {/* Mobile Number */}
                <Col sm={24} md={8} className="mt-3">
                  <label className="font-semibold">Mobile Number</label>
                  <Input
                    required
                    value={mobile}
                    placeholder="Enter mobile number"
                    maxLength={10}
                    className="mt-1"
                    disabled
                  />
                </Col>
                {/* Email Id */}
                <Col sm={24} md={8} className="mt-3">
                  <label className="font-semibold">Email</label>
                  <Input value={email} disabled className="mt-1" />
                </Col>
                {/* Date of Birth */}
                <Col sm={24} md={8} className="mt-3 w-100">
                  <label className="font-semibold">Date of Birth</label> <br />
                  <DatePicker
                    required
                    className="w-100 mt-1"
                    format="DD-MM-YYYY"
                    value={dob}
                    onChange={(date) => setDob(date)}
                  />
                </Col>
                {/* Blood Group */}
                <Col sm={24} md={8} className="mt-3 w-100">
                  <label className="font-semibold">Blood Group</label>
                  <Select
                    required
                    className="w-100 mt-1"
                    placeholder="Select type"
                    value={bloodGroup}
                    onChange={(value) => setBloodGroup(value)}
                  >
                    <Option value="A+">A+</Option>
                    <Option value="A-">A-</Option>
                    <Option value="B+">B+</Option>
                    <Option value="B-">B-</Option>
                    <Option value="O+">O+</Option>
                    <Option value="O-">O-</Option>
                    <Option value="AB+">AB+</Option>
                    <Option value="AB-">AB-</Option>
                  </Select>
                </Col>
                {/*  Gender */}
                <Col sm={24} md={8} className="mt-3">
                  <label className="font-semibold">Gender</label>
                  <Select
                    required
                    className="full-width mt-1"
                    placeholder="Select type"
                    value={gender}
                    onChange={(value) => setGender(value)}
                  >
                    <Option value="1">Male</Option>
                    <Option value="2">Female</Option>
                  </Select>
                </Col>
                {/* Passout Class */}
                <Col sm={24} md={8} className="mt-3">
                  <label className="font-semibold">
                    School Passout Class (Year)
                  </label>
                  <Input
                    required
                    value={dropoutClass}
                    onChange={(e) => setDropoutClass(e.target.value)}
                    placeholder="Enter Passout Class"
                    className="mt-1"
                  />
                </Col>
                {/* Education */}
                <Col sm={24} md={12} className="mt-3">
                  <label className="font-semibold">Education</label>
                  <Input
                    required
                    value={education}
                    onChange={(e) => setEducation(e.target.value)}
                    placeholder="Enter education"
                    className="mt-1"
                  />
                </Col>
                {/* Occupation */}
                <Col sm={24} md={12} className="mt-3">
                  <label className="font-semibold">Occupation</label>
                  <Input
                    required
                    value={occupation}
                    onChange={(e) => setOccupation(e.target.value)}
                    placeholder="Enter occupation"
                    className="mt-1"
                  />
                </Col>

                {/* New Photo Upload */}
                <Col sm={24} md={12} className="mt-3">
                  <label className="font-semibold">
                    Upload Student's New Photo
                  </label>

                  <Input
                    key={fileKey} // This resets the input
                    className="full-width mt-1"
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files[0]
                      if (!file) return

                      const maxSize = 8 * 1024 * 1024 // 1 MB

                      if (file.size > maxSize) {
                        toast.error('File size should be less than 8 MB')

                        // 👇 Force re-render input to clear selected file
                        setFileKey(Date.now())
                        return
                      }

                      setStudentNewImage(file)
                    }}
                  />

                  {studentNewImageUrl && (
                    <div className="col-md-6 mt-1 border rounded text-center">
                      <span style={{ color: 'gray' }}>
                        Previous Uploaded Img :
                      </span>{' '}
                      <br />
                      <img
                        src={`${IMG_BASE_URL}${studentNewImageUrl}`}
                        alt="Student"
                        style={{
                          width: 120,
                          height: 120,
                          objectFit: 'fill',
                          borderRadius: 6,
                        }}
                      />
                    </div>
                  )}
                </Col>

                {/* Old Photo Upload */}
                <Col sm={24} md={12} className="mt-3">
                  <label className="font-semibold">
                    Upload Student's Old Photo
                  </label>

                  <Input
                    key={fileKey} // This resets the input
                    className="full-width mt-1"
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files[0]
                      if (!file) return

                      const maxSize = 8 * 1024 * 1024 // 1 MB

                      if (file.size > maxSize) {
                        toast.error('File size should be less than 8 MB')

                        // 👇 Force re-render input to clear selected file
                        setFileKey(Date.now())
                        return
                      }

                      setStudentOldImage(file)
                    }}
                  />

                  {studentOldImageUrl && (
                    <div className="col-md-6 mt-1 border rounded text-center">
                      <span style={{ color: 'gray' }}>
                        Previous Uploaded Img :
                      </span>{' '}
                      <br />
                      <img
                        src={`${IMG_BASE_URL}${studentOldImageUrl}`}
                        alt="Old"
                        style={{
                          width: 120,
                          height: 120,
                          objectFit: 'fill',
                          borderRadius: 6,
                        }}
                      />
                    </div>
                  )}
                </Col>

                {/* Payment Screenshot Upload */}
                <Col sm={24} md={12} className="mt-3">
                  <label className="font-semibold">
                    Upload Payment Screenshot
                  </label>

                  <Input
                    key={fileKey} //  This resets the input
                    className="full-width mt-1"
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files[0]
                      if (!file) return

                      const maxSize = 8 * 1024 * 1024 // 1 MB

                      if (file.size > maxSize) {
                        toast.error('File size should be less than 8 MB')

                        // Force re-render input to clear selected file
                        setFileKey(Date.now())
                        return
                      }

                      setPaymentScreenshot(file)
                    }}
                  />

                  {paymentScreenshotUrl && (
                    <div className="col-md-6 mt-1 border rounded text-center">
                      <span style={{ color: 'gray' }}>
                        Previous Uploaded Img :
                      </span>{' '}
                      <br />
                      <img
                        src={`${IMG_BASE_URL}${paymentScreenshotUrl}`}
                        alt="Payment"
                        style={{
                          width: 120,
                          height: 120,
                          objectFit: 'fill',
                          borderRadius: 6,
                        }}
                      />
                    </div>
                  )}
                </Col>

                {/*  Questions */}
                <Col sm={24} md={12} className="mt-4">
                  <label className="font-semibold">
                    In what way will you be attending the Mahamaitra Gathering?
                  </label>
                  <Select
                    required
                    className="full-width mt-1"
                    placeholder="Select type"
                    value={wayOfAttending}
                    onChange={(value) => setWayOfAttending(value)}
                  >
                    <Option value="1">Residential</Option>
                    <Option value="2">Non-Residential</Option>
                  </Select>
                </Col>

                <Col sm={24} md={12} className="mt-4">
                  <label className="font-semibold">
                    What is the type of entry?
                  </label>
                  <Select
                    required
                    className="full-width mt-1"
                    placeholder="Select type"
                    value={entryType}
                    onChange={(value) => setEntryType(value)}
                  >
                    <Option value="1">Day Learner</Option>
                    <Option value="2">Hostel</Option>
                  </Select>
                </Col>

                <Col sm={24} md={12} className="mt-4">
                  <label className="font-semibold">
                    Are you joining us for the Suvarna Mahotsavi Mahamaitra
                    Gathering (सुवर्ण महोत्सवी महामैत्र मेळा) on?
                  </label>
                  <Select
                    required
                    className="full-width mt-1"
                    placeholder="Select type"
                    value={confirmationForJoining}
                    onChange={(value) => setConfirmationForJoining(value)}
                  >
                    <Option value="1">24th & 25th January 2026</Option>
                    <Option value="2">Only 25th January 2026</Option>
                  </Select>
                </Col>

                <Col sm={24} md={12} className="mt-4">
                  <label className="font-semibold">
                    Will you be sending articles, memories, poems, stories and
                    incidents by 20th December 2025?
                  </label>
                  <Select
                    required
                    className="full-width mt-1"
                    placeholder="Select type"
                    value={sendingArticlePoems}
                    onChange={(value) => setSendingArticlePoems(value)}
                  >
                    <Option value="1">Yes</Option>
                    <Option value="2">No</Option>
                  </Select>
                </Col>

                {/*  House No */}
                <Col sm={24} md={12} className="mt-4">
                  <label className="font-semibold">Select House Number</label>
                  <Select
                    required
                    className="full-width mt-1"
                    placeholder="Select house"
                    value={houseNo}
                    onChange={(value) => setHouseNo(value)}
                  >
                    <Option value="1">House 1</Option>
                    <Option value="2">House 2</Option>
                    <Option value="3">House 3</Option>
                    <Option value="4">House 4</Option>
                    <Option value="5">House 5</Option>
                    <Option value="6">House 6</Option>
                    <Option value="7">House 7</Option>
                    <Option value="8">House 8</Option>
                  </Select>
                </Col>
              </Row>

              <Row justify="end" className="mt-4">
                <Space>
                  <Button onClick={() => setEditModal(false)}>Cancel</Button>

                  <Button
                    type="primary"
                    loading={loading}
                    onClick={handleUpdate}
                  >
                    Update
                  </Button>
                </Space>
              </Row>
            </>
          </Modal>
        </div>

        <div className="col-12 col-md-2"></div>
      </div>

      <Footer />
    </div>
  )
}

export default RegApprovedList
